// Visual tokens for the document scanning section.
//
// Document scanning is a separate offer from mail scanning and must read that
// way: same wordmark, different service label, different accent. Mail keeps
// HotSnail red; scanning is indigo. Anything in this section that would
// otherwise reach for theme.colors.secondary uses ACCENT instead.

export const ACCENT = "#4F46E5";
export const ACCENT_DARK = "#3730A3";
export const ACCENT_TINT = "#EEF2FF";

export const INK = "#0F172A";
export const BODY = "#475569";
export const MUTED = "#64748B";
export const FAINT = "#94A3B8";

export const LINE = "#E2E8F0";
export const HAIRLINE = "#F1F5F9";
export const SURFACE = "#F8FAFC";

// The mail brand, used only where the scanning pages point back at mail.
export const MAIL_RED = "#EF4136";
export const MAIL_RED_DARK = "#B91C1C";
export const MAIL_TINT = "#FEF2F2";
export const MAIL_LINE = "#FECACA";

export const scanNav = [
  { to: "/document-scanning/", label: "Overview" },
  { to: "/document-scanning/how-it-works/", label: "How it works" },
  { to: "/document-scanning/pricing/", label: "Pricing" },
  { to: "/document-scanning/ai-indexing/", label: "AI indexing" },
  { to: "/document-scanning/custom-workflows/", label: "Custom workflows" },
  { to: "/document-scanning/security/", label: "Security" },
  { to: "/document-scanning/gold-coast/", label: "Gold Coast" },
  { to: "/document-scanning/brisbane/", label: "Brisbane" },
];
